<template lang="pug">
.LogPopup
  .LogPopup-header
    h2 Лог обработки слоя "{{ title }}"
  .LogPopup-body
    log.Version-log(:htmlText='htmlText')
  .LogPopup-footer
    button#LogPopup_submit.Btn.Btn--blue(@click='ok') {{ okText }}
    button#LogPopup_cancel.Btn.Btn--grey(@click='cancel') Отмена
</template>

<script>
import Log from '@/components/modeling/Log.vue'

export default {
  name: 'LogPopup',
  components: {
    Log
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    okText: {
      type: String,
      default: 'ОК'
    }
  },

  computed: {
    htmlText() {
      return this.text.replace(/; /g, ';<br />')
    }
  },

  methods: {
    ok() {
      this.$ui.popup.ok('ok')
    },
    cancel() {
      this.$ui.popup.ok('cancel')
    }
  }
}
</script>

<style lang="scss">
@import '~base';

.Popup .LogPopup {
  --footerBorder: #{$grey3};
}

.Popup[data-theme='dark'] .LogPopup {
  --footerBorder: #{$grey2};
}
</style>
<style scoped lang="scss">
@import '~base';

.LogPopup {
  position: relative;

  &-header {
    padding: 25px 30px 15px;

    h2 {
      margin-bottom: 0;
      font-size: 16px;
      text-transform: uppercase;
    }
  }

  &-body {
    padding: 10px 30px 30px 30px;
  }

  &-footer {
    padding: 5px 30px 10px;
    border-top: 1px solid var(--footerBorder);

    .Btn {
      min-width: 155px;
      font-size: 11px;
      font-weight: 300;
      text-transform: uppercase;
    }

    .Btn + .Btn {
      margin-left: 12px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/popups/Log.vue